import { guestForkPaths } from '../home/guestFork';
import { handleForkAndRun, type ForkApiFn } from '../landing/forkFlow';

export async function useCertifiedPlaybook(opts: {
  outcomeId: string;
  loggedIn: boolean;
  navigate: (path: string) => void;
  forkApi: ForkApiFn;
}): Promise<{ ok: boolean; error?: string }> {
  if (!opts.loggedIn) {
    opts.navigate(guestForkPaths(`/studio?fork=${encodeURIComponent(opts.outcomeId)}`).register);
    return { ok: false };
  }
  const result = await handleForkAndRun({
    outcomeId: opts.outcomeId,
    loggedIn: true,
    navigate: opts.navigate,
    forkApi: opts.forkApi,
  });
  if (!result.success) return { ok: false, error: result.error };
  return { ok: true };
}
